// @flow
import ContactFormAccreditations from 'components/contact/ContactFormAccreditations';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/contact/ContactFormAccreditations';
import { postContactForm, fetchAllContactForm } from 'actions/formActions';

export default withRouter(connect(
  (state: StateType): StateProps => ({
    accreditations: state.settingsState.accreditations,
    contactForm: state.formState.contactFormList,
    fetchStatus: state.formState.fetchStatus,
    sendStatus: state.formState.sendStatus
  }),
  (dispatch: DispatchType): DispatchProps => ({
    postContactForm: (formInputs: Object, id: number) => dispatch(postContactForm(formInputs, id)),
    fetchContactForm: () => dispatch(fetchAllContactForm()),
  })
)(ContactFormAccreditations));